import { LogOut } from 'lucide-react';
import { useAdminDownloads } from '../hooks/useAdminDownloads';
import { AdminDownloadCard } from './AdminDownloadCard';

export const AdminDashboard = ({ user, onSignOut }) => {
  const { downloads, loading, error, activeDownload, download } = useAdminDownloads();

  return (
    <main className="min-h-screen bg-slate-950 text-white" data-testid="admin-dashboard">
      <header className="border-b border-slate-800 bg-slate-950/90">
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between gap-5">
          <div>
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-emerald-400">TweePorter</p>
            <h1 className="text-2xl font-black tracking-tight mt-1">Module library</h1>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <p className="text-sm text-slate-200" data-testid="admin-user-name">{user.name}</p>
              <p className="text-xs text-slate-500" data-testid="admin-user-email">{user.email}</p>
            </div>
            <button type="button" onClick={onSignOut} data-testid="admin-logout-button" className="rounded-lg border border-slate-700 px-3 py-2 text-sm text-slate-300 hover:border-slate-500 hover:text-white flex items-center gap-2 transition-[color,border-color]">
              <LogOut size={15} aria-hidden="true" /> Sign out
            </button>
          </div>
        </div>
      </header>

      <section className="max-w-6xl mx-auto px-6 py-16">
        <p className="text-slate-400 max-w-2xl leading-relaxed mb-10">
          Download versioned, self-contained integration packages. Access through this application is restricted to approved administrators.
        </p>
        {error && <div className="mb-6 rounded-lg border border-red-800 bg-red-950/40 px-4 py-3 text-sm text-red-300" data-testid="admin-download-error">{error}</div>}
        {loading ? (
          <p className="text-slate-500" data-testid="admin-downloads-loading">Loading module catalog…</p>
        ) : (
          <div className="grid md:grid-cols-2 gap-6" data-testid="admin-download-list">
            {downloads.map(item => (
              <AdminDownloadCard key={item.id} item={item} active={activeDownload === item.id} onDownload={download} />
            ))}
          </div>
        )}
        <a href="/" data-testid="admin-dashboard-home-link" className="inline-block mt-10 text-sm text-slate-500 hover:text-slate-300 transition-colors">Return to TweePorter</a>
      </section>
    </main>
  );
};
